<script setup>
import { computed } from 'vue';
import { LEVELLING_METHOD } from '@rm-ui/levelling/levellingMeta';

const props = defineProps({
  method: { type: String, default: null },
});

const meta = computed(() => (props.method ? LEVELLING_METHOD[props.method] : null));
</script>

<template>
  <span v-if="meta" class="cc-method">
    <span class="ms cc-method-icon">{{ meta.icon }}</span>
    {{ meta.label }}
  </span>
  <span v-else class="cc-method cc-method--none">—</span>
</template>

<style lang="scss" scoped>
/* Prototype lvl-method — 13.5px, text-2. */
.cc-method {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13.5px;
  color: var(--cc-text-2, #555555);
  white-space: nowrap;

  .cc-method-icon {
    font-size: 15px;
    color: var(--cc-text-3, #888888) !important;
  }

  &.cc-method--none {
    color: var(--cc-text-3, #bbbbbb);
  }
}
</style>
